import React from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import * as yup from 'yup'
import { Field, Formik } from 'formik'

import TextField from '../TextField'
import Button from '../Button'
import Form, { Heading } from '../Form'

const CREATE_MANUFACTURER = gql`
  mutation createManufacturer($name: String!) {
    createManufacturer(name: $name) {
      id
      name
      models {
        id
      }
    }
  }
`

var validationSchema = yup.object().shape({
  name: yup.string().required('Name is required.')
})

const INITIAL_VALUES = {
  name: ''
}

const onSubmit = (values, {setSubmitting}, createManufacturer) => {
  createManufacturer({variables: values})
  setSubmitting(false)
}

const Create = ({onCompleted, onError}) =>
  <Mutation
    mutation={CREATE_MANUFACTURER}
    onCompleted={onCompleted}
    onError={onError}>
    {(createManufacturer, {loading}) =>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions, createManufacturer)}>
        {({isSubmitting}) =>
          <Form>
            <Heading>General</Heading>
            <Field component={TextField} name='name' required autoComplete='off' />
            <Button type='submit' fluid disabled={loading || isSubmitting}>Create New Manufacturer</Button>
          </Form>
        }
      </Formik>
    }
  </Mutation>

export default Create


// WEBPACK FOOTER //
// ./src/components/Manufacturers/Create.js